
(function () {
  function replaceFlags(root = document) {
    const flagRegex = /[\u{1F1E6}-\u{1F1FF}]{2}/gu;

    // Target BOTH areas
    root.querySelectorAll(
      ".yotpo-reviewer-name, .metafield-rich_text_field p"
    ).forEach(el => {
      if (el.dataset.flagDone) return;
      el.dataset.flagDone = "true";

      el.innerHTML = el.innerHTML.replace(flagRegex, function(flag) {
        // Convert emoji flag to country code (e.g. 🇯🇵 → jp)
        const code = Array.from(flag)
          .map(char => char.codePointAt(0) - 0x1F1E6 + 65)
          .map(n => String.fromCharCode(n))
          .join("")
          .toLowerCase();

        // Add margin only for Yotpo name
        const extraStyle = el.classList.contains("yotpo-reviewer-name")
          ? "margin-left:6px;"
          : "";

        return `<img 
          src="https://flagcdn.com/w320/${code}.png"
          alt="${code.toUpperCase()}"
          style="width:18px;height:12px;vertical-align:middle;border-radius:3px;${extraStyle}"
        />`;
      });
    });
  }

  // Initial run
  replaceFlags();

  // Watch for dynamically added content
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) replaceFlags(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".tab-buttons-meta").forEach(tabWrapper => {

    const buttons = tabWrapper.querySelectorAll(".tab-btn-meta");
    const mainWrapper = tabWrapper.parentElement;
    const contents = mainWrapper.querySelectorAll(".tab-content-meta");

    buttons.forEach(btn => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const target = this.dataset.tab;

        buttons.forEach(b => b.classList.remove("active-meta"));
        contents.forEach(c => c.classList.remove("active-meta"));

        this.classList.add("active-meta");

        const tab = mainWrapper.querySelector("#" + target);
        if (tab) {
          tab.classList.add("active-meta");
        }
      });
    });

  });
});

(function () {

  function processContainer(container) {
    if (container.dataset.metaWrapped === "true") return;
    container.dataset.metaWrapped = "true";

    const nodes = Array.from(container.childNodes);
    let wrapper = null;

    nodes.forEach(node => {

      // Start wrapper on IMG
      if (node.nodeType === 1 && node.tagName === 'IMG') {
        wrapper = document.createElement('div');
        wrapper.className = 'meta-country';
        container.insertBefore(wrapper, node);
        wrapper.appendChild(node);
        return;
      }

      // Append text nodes and inline elements
      if (
        wrapper &&
        (
          node.nodeType === 3 ||
          (node.nodeType === 1 && node.tagName !== 'BR')
        )
      ) {
        wrapper.appendChild(node);
        return;
      }

      // Close wrapper on BR
      if (wrapper && node.nodeType === 1 && node.tagName === 'BR') {
        wrapper = null;
        container.removeChild(node);
      }

    });
  }

  function scan() {
    document
      .querySelectorAll('[data-flag-done="true"]')
      .forEach(processContainer);
  }

  // Run on initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  // Watch for popup / dynamic content
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;

        // If the added node IS a container
        if (node.matches?.('[data-flag-done="true"]')) {
          processContainer(node);
        }

        // Or contains one
        node
          .querySelectorAll?.('[data-flag-done="true"]')
          .forEach(processContainer);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


const productDescription = document.querySelector('.product-descruption');

document.querySelectorAll('.tab-btn-meta').forEach(btn => {
  btn.addEventListener('click', function () {

    // remove active from all
    document.querySelectorAll('.tab-btn-meta').forEach(b =>
      b.classList.remove('active-meta')
    );

    // add active to clicked button
    this.classList.add('active-meta');

    // toggle class on description
    productDescription.classList.toggle(
      'meta-active-descruption',
      this.dataset.tab === 'tab-included'
    );
  });
});




document.addEventListener("click", function (e) {

  const acc = e.target.closest(".tabcontent.active-panel .accordion");
  if (!acc) return;

  const activeTab = acc.closest(".tabcontent.active-panel");
  if (!activeTab) return;

  // Close all other accordions in this tab
  activeTab.querySelectorAll(".accordion.activea").forEach(openAcc => {
    if (openAcc !== acc) {
      openAcc.classList.remove("activea");

      const openPanel = openAcc.nextElementSibling;
      if (openPanel) {
        openPanel.style.maxHeight = null;
        openPanel.style.display = "none";
      }
    }
  });

  // Toggle clicked accordion
  acc.classList.toggle("activea");

  const panel = acc.nextElementSibling;
  if (!panel) return;

  if (acc.classList.contains("activea")) {
    panel.style.display = "block";
    panel.style.maxHeight = panel.scrollHeight + "px";
  } else {
    panel.style.maxHeight = null;
    setTimeout(() => {
  panel.style.display = "none";
}, 600);
  }

});




document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll('.tablinks');
  const contents = document.querySelectorAll('.tabcontent');

  function activateTab(tab) {
    // Remove active from all
    tabs.forEach(btn => btn.classList.remove('active-accordian'));
    contents.forEach(content => content.classList.remove('active-panel'));

    // Add active to selected
    tab.classList.add('active-accordian');

    const targetContent = document.querySelector('.tabcontent#' + tab.id);
    if (targetContent) {
      targetContent.classList.add('active-panel');
    }
  }

  // Click handling
  tabs.forEach(button => {
    button.addEventListener('click', function () {
      activateTab(this);
    });
  });

  // ✅ Default active = FAQs
  const defaultTab = document.querySelector('.tablinks#FAQs');
  if (defaultTab) {
    activateTab(defaultTab);
  }

});

document.querySelectorAll('.faq-item').forEach(details => {
  const summary = details.querySelector('summary');
  const content = details.querySelector('.faq-answer');

  // Init
  if (details.hasAttribute('open')) {
    content.style.height = content.scrollHeight + 'px';
    content.style.opacity = 1;
  } else {
    content.style.height = '0px';
    content.style.opacity = 0;
  }

  summary.addEventListener('click', e => {
    e.preventDefault();

    const isOpen = details.hasAttribute('open');

    // 🔒 Close all other FAQ items first
    document.querySelectorAll('.faq-item').forEach(item => {
      if (item !== details && item.hasAttribute('open')) {
        const otherContent = item.querySelector('.faq-answer');

        // Animate close for others
        const h = otherContent.scrollHeight;
        otherContent.style.height = h + 'px';

        requestAnimationFrame(() => {
          otherContent.style.height = '0px';
          otherContent.style.opacity = 0;
        });

        otherContent.addEventListener('transitionend', () => {
          item.removeAttribute('open');
        }, { once: true });
      }
    });

    if (isOpen) {
      // CLOSE current
      const h = content.scrollHeight;
      content.style.height = h + 'px';

      requestAnimationFrame(() => {
        content.style.height = '0px';
        content.style.opacity = 0;
      });

      content.addEventListener('transitionend', () => {
        details.removeAttribute('open');
      }, { once: true });

    } else {
      // OPEN current
      details.setAttribute('open', '');
      const h = content.scrollHeight;

      content.style.height = '0px';
      content.style.opacity = 0;

      requestAnimationFrame(() => {
        content.style.height = h + 'px';
        content.style.opacity = 1;
      });

      content.addEventListener('transitionend', () => {
        content.style.height = 'auto';
      }, { once: true });
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".tabcontent .accordion").forEach(btn => {
    const panel = btn.nextElementSibling;

    // Only wrap if not already wrapped
    if (!btn.parentElement.classList.contains("collection-faq-item")) {
      const wrapper = document.createElement("div");
      wrapper.className = "collection-faq-item";

      btn.parentNode.insertBefore(wrapper, btn);
      wrapper.appendChild(btn);
      if (panel && panel.classList.contains("panel")) {
        wrapper.appendChild(panel);
      }
    }
  });
});




